























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import VueApexCharts from 'vue-apexcharts';
import thinBar from '@/data/thin-bar-graph';
import thinDonut from '@/data/thin-donut-chart';

@Component({
  components: {
    VueApexCharts,
  }
})
export default class TrendChart extends Vue {
  @Prop({ default: "Pending Consents" }) title!: string;
  @Prop({ default: null}) xAxisData!: string[];
  @Prop({ default: null}) seriesData!: any[];
  @Prop({ default: null}) optionsData!: any[];

  // Thin Bar data object
  thinBar: any = thinBar;
  thinDonut: any = thinDonut;

  get lineSeriesData() {
    return this.seriesData || thinBar.series;
  }

  get lineOptionsData() {
    return this.optionsData || thinBar.options;
  }

  mounted() {
    this.loadContent();
  }

  async loadContent() {}
}
